import React from 'react';
import { Link } from 'react-router-dom';
import { useSEO } from '../hooks/useSEO';

export default function NotFound() {
  useSEO({ title: 'Página não encontrada | MiniMental.com.br', noindex: true });

  return (
    <main className="min-h-[60vh] flex flex-col items-center justify-center px-4 text-center">
      <h1 className="text-6xl font-bold text-[var(--primary)] mb-4">404</h1>
      <h2 className="text-2xl font-semibold mb-6">Página não encontrada</h2>
      <p className="text-[var(--text-muted)] mb-8 max-w-md">
        A página que você está procurando não existe, foi movida ou o endereço está incorreto.
      </p>
      <Link to="/" className="btn-primary">
        Voltar para o início
      </Link>
    </main>
  );
}